const MeterError = [
    {
        name: "Error [%]",
        value: "ERROR",
        unit: "",
        decimals: 3,
    },
    {
        name: "StDev [%]",
        value: "METERSTDEV",
        unit: "",
        decimals: 3
    },
    {
        name: "Samples",
        value: "TESTSAMPLES",
        unit: "",
        decimals: 0
    },
    {
        name: "Int. Period",
        value: "INTTIME",
        unit: "s",
        decimals: 0
    },
    {
        name: "Energy",
        value: "MENERGYTYPE",
        unit: "",
        type: "energy"
    },
    {
        name: "OPS Input",
        value: "ELM_OUTPUT_TYPE",
        unit: "",
        type: "opsinput"
    },
    {
        name: "Constant",
        value: "METERCONST",
        unit: "i/kWh",
        decimals: 0
    },
];

const BasicValues = [
    {
        value: "U",
        unit: "V",
        L1: "MCHNLA1",
        L2: "MCHNLA2",
        L3: "MCHNLA3"
    },
    {
        value: "I",
        unit: "A",
        L1: "MCHNLB1",
        L2: "MCHNLB2",
        L3: "MCHNLB3"
    },
    {
        value: "cos φ",
        unit: "",
        L1: "MPOWFACT1",
        L2: "MPOWFACT2",
        L3: "MPOWFACT3"
    },
    {
        value: "φU",
        unit: "°",
        L1: "MPHA1",
        L2: "MPHA2",
        L3: "MPHA3"
    },
    {
        value: "φUI",
        unit: "°",
        L1: "MPHB1",
        L2: "MPHB2",
        L3: "MPHB3"
    },
    {
        value: "DFᵤ",
        unit: "%",
        L1: "DFA1",
        L2: "DFA2",
        L3: "DFA3"
    },
    {
        value: "DFᵢ",
        unit: "%",
        L1: "DFB1",
        L2: "DFB2",
        L3: "DFB3"
    },
    {
        value: "f",
        unit: "Hz",
        L1: "",
        L2: "MFREQ",
        L3: ""
    },
    {
        value: "Uₚₚ",
        unit: "V",
        L1: "UPP1",
        L2: "UPP2",
        L3: "UPP3"
    },
    {
        value: "φUₚₚ",
        unit: "°",
        L1: "PH1",
        L2: "PH2",
        L3: "PH3"
    },
    {
        value: "sin φ",
        unit: "",
        L1: "SINPH1",
        L2: "SINPH2",
        L3: "SINPH3"
    },
    {
        value: "Iₚ",
        unit: "A",
        L1: "Ip_L1",
        L2: "Ip_L2",
        L3: "Ip_L3"
    },
    {
        value: "Iǫ",
        unit: "A",
        L1: "Iq_L1",
        L2: "Iq_L2",
        L3: "Iq_L3"
    },
    {
        value: "Z",
        unit: "Ω",
        L1: "Z_L1",
        L2: "Z_L2",
        L3: "Z_L3"
    },
    {
        value: "φz",
        unit: "°",
        L1: "MPHB1",
        L2: "MPHB2",
        L3: "MPHB3"
    },
];

const PowerValues = [
    {
        value: "P",
        unit: "W",
        L1: "MPOWER1",
        L2: "MPOWER2",
        L3: "MPOWER3"
    },
    {
        value: "Q",
        unit: "var",
        L1: "MQPOWER1",
        L2: "MQPOWER2",
        L3: "MQPOWER3"
    },
    {
        value: "S",
        unit: "VA",
        L1: "MSPOWER1",
        L2: "MSPOWER2",
        L3: "MSPOWER3"
    },
    {
        value: "ΣP",
        unit: "W",
        L1: "",
        L2: "MPOWERSUM",
        L3: ""
    },
    {
        value: "ΣQ",
        unit: "var",
        L1: "",
        L2: "MQPOWERSUM",
        L3: ""
    },
    {
        value: "ΣS",
        unit: "VA",
        L1: "",
        L2: "MSPOWERSUM",
        L3: ""
    },
];

const EnergyValues = [
    {
        value: "Eₚ",
        unit: "Ws",
        L1: "MENERGY1",
        L2: "MENERGY2",
        L3: "MENERGY3"
    },
    {
        value: "Eǫ",
        unit: "vars",
        L1: "MQENERGY1",
        L2: "MQENERGY2",
        L3: "MQENERGY3"
    },
    {
        value: "Eₛ",
        unit: "VAs",
        L1: "MSENERGY1",
        L2: "MSENERGY2",
        L3: "MSENERGY3"
    },
    {
        value: "ΣEₚ",
        unit: "Ws",
        L1: "",
        L2: "MENERGYSUM",
        L3: ""
    },
    {
        value: "ΣEǫ",
        unit: "vars",
        L1: "",
        L2: "MQENERGYSUM",
        L3: ""
    },
    {
        value: "ΣEₛ",
        unit: "VAs",
        L1: "",
        L2: "MSENERGYSUM",
        L3: ""
    },
];

const MaximumDemand = [
    {
        name: "Period",
        value: "MDPERIOD",
        unit: "",
        decimals: 0
    },
    {
        name: "SubPeriods",
        value: "MDSUBPERIODS",
        unit: "",
        decimals: 0
    },
    {
        name: "Last Reset",
        value: "MDLASTRESET",
        unit: "",
        type: "ts"
    },
    {
        name: "Fix Active",
        value: "MDFIXACTIVE",
        unit: "kW",
        decimals: 3
    },
    {
        name: "Fix Reactive",
        value: "MDFIXREACTIVE",
        unit: "kvar",
        decimals: 3
    },
    {
        name: "Fix Apparent",
        value: "MDFIXAPPARENT",
        unit: "kVA",
        decimals: 3
    },
    {
        name: "Slide Active",
        value: "MDSLIDACTIVE",
        unit: "kW",
        decimals: 3
    },
    {
        name: "Slide Reactive",
        value: "MDSLIDREACTIVE",
        unit: "kvar",
        decimals: 3
    },
    {
        name: "Slide Apparent",
        value: "MDSLIDAPPARENT",
        unit: "kVA",
        decimals: 3
    }
];

export {
    MeterError,
    BasicValues,
    PowerValues,
    EnergyValues,
    MaximumDemand
}